import { getPdfTotal } from 'api/pdf';
import { useApi } from 'hooks';
import { createContext, FunctionComponent, h } from 'preact';
import { useContext, useEffect, useMemo, useState } from 'preact/hooks';
import { sendPostMessage } from 'helpers/post-message.helper';
import { ApplicationContext } from './use-application-setup';

type RemediationsContextType = {
  totalAppliedRemediations: number;
  totalPdf: number;
};

const PDF_RULE = 'REMEDIATION_PDF_DOCUMENTS';

export const RemediationsContext = createContext<RemediationsContextType | null>(null);

export const RemediationsProvider: FunctionComponent = ({ children }) => {
  const Api = useApi();
  const { thisSiteId } = useContext(ApplicationContext);

  const [helpersOutcome, setHelpersOutcome] = useState<
    Record<string, { countFixed: number; countTodo: number }>
  >({});
  const [totalPdf, setTotalPdf] = useState<number>(0);

  const totalAppliedRemediations = Object.entries(helpersOutcome).reduce((acc, [key, value]) => {
    if (key === PDF_RULE || !value) return acc;
    const { countFixed = 0, countTodo = 0 } = value;
    return acc + countFixed + countTodo;
  }, 0);

  useEffect(() => {
    sendPostMessage({
      action: 'remediation',
      type: 'all-data',
    });

    const handler = (event: MessageEvent) => {
      const data = event.data;
      if (data?.action === 'remediation' && data.type === 'all-data') {
        const newHelpersOutcome = data.data ?? {};
        setHelpersOutcome(newHelpersOutcome);
      }
    };

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
  }, []);

  useEffect(() => {
    if (helpersOutcome[PDF_RULE]) {
      getPdfTotal(Api, thisSiteId)
        .then(setTotalPdf)
        .catch((error) => {
          console.log(error);
        });
    } else {
      setTotalPdf(0);
    }
  }, [helpersOutcome, Api, thisSiteId]);

  const contextValue = useMemo(
    () => ({ totalAppliedRemediations, totalPdf }),
    [totalAppliedRemediations, totalPdf],
  );

  return (
    <RemediationsContext.Provider value={contextValue}>{children}</RemediationsContext.Provider>
  );
};
